import { reviews } from '@/mocks/home';

const renderStars = (score: number) =>
  Array.from({ length: 5 }, (_, i) => (
    <i
      key={i}
      className={`text-sm ${i < score ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
    />
  ));

export default function Reviews() {
  return (
    <section id="reviews" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60">
      <div className="max-w-6xl mx-auto">
        <div className="reveal max-w-2xl">
          <span className="text-primary-600 font-label text-sm tracking-wide">影评口碑</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            当年的评价，几乎一边倒
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            与原版被岁月不断美化不同，3D 版上映后收获的批评相当集中。下面按来源整理，星星代表综合口碑倾向，仅供参考。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {reviews.map((item, index) => (
              <div
                key={item.source}
                className="reveal bg-background-50 border border-background-200/80 rounded-lg p-5 md:p-6"
                style={{ animationDelay: `${index * 60}ms` }}
              >
                <div className="flex items-center justify-between gap-3">
                  <p className="font-label text-xs md:text-sm text-foreground-900 font-medium">{item.source}</p>
                  <span className="flex items-center gap-0.5">{renderStars(item.score)}</span>
                </div>
                <p className="mt-3 text-foreground-600 text-xs md:text-sm leading-relaxed">{item.verdict}</p>
              </div>
            ))}
          </div>

          <div className="reveal bg-background-950 rounded-lg overflow-hidden flex flex-col">
            <div className="h-[180px] md:h-[220px]">
              <img
                src="https://readdy.ai/api/search-image?query=Empty%20vintage%20cinema%20theater%20with%20warm%20amber%20and%20peach%20lighting%2C%20red%20velvet%20seats%2C%20soft%20dusty%20atmosphere%2C%20grainy%20film%20texture%2C%20nostalgic%20cinematic%20mood%2C%20artistic%20composition%2C%20no%20text&width=1000&height=750&seq=peach-review-01&orientation=landscape"
                alt="暖光下空荡的老式影院，呼应影评口碑的主题"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 flex-1 flex flex-col justify-center">
              <p className="text-accent-400 font-label text-xs">综合印象</p>
              <p className="mt-2 font-heading text-lg md:text-xl font-bold text-background-50">
                “借了情怀的光，也背了情怀的债。”
              </p>
              <p className="mt-3 text-background-50/70 text-xs md:text-sm leading-relaxed">
                经典 IP 带来的高期待，最终大多转化成了失望。这也是它和原版口碑差距越拉越大的根本原因。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}